import r from "./highrise1312.mjs";
var a = r["__core-js_shared__"];
export {
  a as default
};
